
<template>
  <div>
      <div class="my-input" :class="{ 'no-label' : label === '','my-input-disabled' : disabled,'uppercase-text': uppertext }" >
          <label class="input-color-label" v-if="label !== ''"> {{ label }} </label>
          <div class="input-row">
              <input :type="resolvedType" :maxlength="maxlength" :inputmode="onlyNumber ? 'numeric' : null" @focus="$emit('focus',value)" @keyup="$emit('keyup',value)" :disabled="disabled" :value="value" v-on:input="updateValue($event)" :placeholder="placeholder"   />
              <button v-if="isPassword" type="button" class="password-toggle" :disabled="disabled" :aria-label="toggleLabel" :title="toggleLabel" @click="isVisible = !isVisible">
                  <i :class="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
          </div>
          <div class="right-addon-icon">
              <slot name="right-icon"></slot>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        label:{
            type : String,
            default : 'Label'
        },
        placeholder:{
            type : String,
            default : ''
        },
        disabled:{
            type : Boolean,
            default : false
        },
        uppertext:{
            type : Boolean,
            default  :false
        },
        type : {
            type : String,
            default : 'text'
        },
        maxlength : {
            type : [String, Number],
            default : null
        },
        onlyNumber : {
            type : Boolean,
            default : false
        },
        value : {}
    },
    data(){
        return{
            // inputVal : ''
            isVisible : false
        }
    },
    computed:{
        isPassword(){
            return this.type === 'password'
        },
        // Ko'rsatish yoqilganda inputni text'ga o'tkazamiz; type propi o'zgarmaydi
        resolvedType(){
            return this.isPassword && this.isVisible ? 'text' : this.type
        },
        toggleLabel(){
            return this.isVisible ? this.$t('hidePassword') : this.$t('showPassword')
        }
    },
    methods:{
        updateValue: function (e) {
            let value = e && e.target ? e.target.value : e
            if (this.onlyNumber) {
                value = String(value).replace(/\D/g, '')
                if (this.maxlength) value = value.slice(0, Number(this.maxlength))
                // Faqat raqam qolgani uchun DOMdagi qiymatni ham majburan yangilaymiz
                if (e && e.target && e.target.value !== value) {
                    e.target.value = value
                }
            }
            this.$emit('input', this.uppertext ? value.toUpperCase() : value)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.my-input{
    display: block;
    border-radius: 12px;
    width: 100%;
    background-color: #F7F7F7;
    position: relative;
    
    .right-addon-icon{
        position: absolute;
        top : 15px;
        right: 15px;
        vertical-align: middle;
        cursor: pointer;
    }
    label{
        width: 100%;
        padding-left: 16px;
        text-transform: uppercase;
        font-size: 12px;
    }
    /* Input va parol tugmasi bir qatorda — tugma balandlik bo'yicha o'zi
       markazlashadi, label bor/yo'qligidan qat'i nazar. */
    .input-row{
        display: flex;
        align-items: center;
    }
    .password-toggle{
        flex: 0 0 auto;
        border: none;
        background: transparent;
        color: $input-text-placeholder;
        padding: 0 16px;
        margin-bottom: 8px;
        line-height: 1;
        cursor: pointer;
        &:hover:not(:disabled){
            color: $primary;
        }
        &:disabled{
            cursor: not-allowed;
        }
    }
    input{
        flex: 1 1 auto;
        min-width: 0;
        width: 100%;
        outline: none;
        border: none;
        background-color: #F7F7F7;
        padding-left: 16px;
        border-radius: 12px;
        margin-bottom: 8px;
        &::placeholder{
            color: $input-text-placeholder;
        }
        /* type="number" da chiqadigan strelkalarni yashiramiz */
        &[type="number"]{
            -moz-appearance: textfield;
            appearance: textfield;
        }
        &[type="number"]::-webkit-outer-spin-button,
        &[type="number"]::-webkit-inner-spin-button{
            -webkit-appearance: none;
            margin: 0;
        }
    }
    
}
.my-input.my-input-disabled input{
    cursor: not-allowed;
}
.no-label{
    padding-top: 16px;
    padding-bottom: 8px;
    .input-color-label{
        display: none;
    }
}
.uppercase-text input{
    text-transform: uppercase;
}
</style>